import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { CUSTOM_VEHICLE_MAKE_ID } from '../../common/constants/index';

export const GET_MAKES = gql`
  query GetVehicleMakes($source: String) {
    vehicleMakes(source: $source) {
      id
      name
    }
  }
`;

export default function useVehicleMakes(source) {
  return useQuery(GET_MAKES, {
    variables: { source },
  });
}

export const useVehicleMakeOptions = (makes, activeMake) => useMemo(
  () => {
    const options = (makes || []).map(({ id, name }) => ({
      label: name,
      value: id,
    }));

    if (activeMake && !options.find(m => m.label === activeMake)) {
      options.push({ label: activeMake, value: CUSTOM_VEHICLE_MAKE_ID });
    }

    return options;
  },
  [makes, activeMake],
);
